
import { mapState } from 'vuex'
export default {
    name: 'ApplyWithdrawal',
    middleware: ['checkAuth'],
    data: () => ({
        valid: false,
        amount: '',
        player_bank_account_id: null,
        paymentTypeCode: 'bank_transfer',
        bankAccountName: {},
        bankAccountList: [],
        playerCurrency: {
            min: 0,
            max: 0,
        },
        companyBankIsNotAvailable: false,
        providerId: null,
    }),
    computed: {
        ...mapState({
            loading: (state) => state.withdrawal.loading,
            bankAccounts: (state) => state.banks.accounts,
            paymentTypes: (state) => state.payment.paymentTypes,
            profile: (state) => state.player.player,
            playerLoading: (state) => state.player.totalBalanceLoading,
            totalBalanceFromSocket: (state) =>
                state.player.totalBalanceFromSocket,
            checkCurrencyAmount: (state) =>
                state.payment.checkDepositAndWithdraw,
            banksList: (state) => state.banks.banks,
        }),
    },
    watch: {
        // ? this watch is used when bank account change
        player_bank_account_id(value) {
            this.playerCurrency.max = this.checkCurrencyAmount.max_paying_amt
            this.playerCurrency.min = this.checkCurrencyAmount.min_paying_amt
        },
        paymentTypes(value) {
            if (value && value.length > 0) {
                const getManualTransfer = value[0].providers.find(
                    (el) => el.code === 'manual_transfer'
                )
                if (getManualTransfer) {
                    this.providerId = getManualTransfer.id
                }
            }
        },
    },
    async mounted() {
        await this.$store.dispatch('banks/accounts')
        await this.$store.dispatch('payment/paymentTypes')
        await this.$store.dispatch('banks/banks')
    },
    methods: {
        async submit() {
            if (this.$refs.formWithdrawal.validate()) {
                const form = {}
                form.amount = parseFloat(this.amount)
                form.player_bank_account_id = this.player_bank_account_id
                form.payment_provider_id = this.providerId

                // ? check withdrawal amount is enough
                await this.$store.dispatch('player/totalBalance')
            }
        },
        onChangeBankAccount(value) {
            const chosenBankAccountDetail = this.bankAccounts.filter(
                (el) => el.id === value
            )
            if (chosenBankAccountDetail.length > 0) {
                this.bankAccountName = {
                    name: chosenBankAccountDetail[0].bank_name,
                    currency: chosenBankAccountDetail[0].bank_account_currency,
                    bank_account_number:
                        chosenBankAccountDetail[0].bank_account_number,
                }
            }
        },
        async onSelectBankName(bankId) {
            this.bankAccount = null
            const response = await this.$store.dispatch(
                'payment/checkDepositAndWithdraw',
                {
                    type: 2,
                    bank_id: bankId,
                    currency_code: this.profile.currency,
                }
            )
            if (!response) this.companyBankIsNotAvailable = true
            else this.companyBankIsNotAvailable = false

            if (this.banksList && this.banksList.length > 0) {
                this.bankAccountList = []
            }
        },
        navigationHistory() {
            this.$router.push('/player/withdrawals')
        },
    },
}
